<template>
    <div>
        <Panel
            id="pacingprofiles_panel"
            :title="$t('Pacing Profiles')"
            :add-button="$store.hasRight('bEditPacingAlgorithms') ? $t('New Profile') : ''"
            :delete-button="selected.length > 0"
            :page="page"
            :total-rows="totalRows"
            @delete="handleDelete"
            @input="openForm(-1)"
            @change="changePage"
        >
            <table id="pacingprofiles_table" class="cic-table">
                <SortableHeader
                    :columns="{
                        name: $t('Profile'),
                        type: $t('Type'),
                        queue: $t('Queue'),
                        dropRatioGoal: $t('Drop Ratio Goal'),
                        initialPacing: $t('Initial Pacing'),
                        maxPacing: $t('Max. Pacing'),
                        minPacing: $t('Min. Pacing'),
                        maxSimultaneous: $t('Simultaneous Call Cap'),
                    }"
                    :delete-column="$store.hasRight('bEditPacingAlgorithms')"
                    :selected="sorted"
                    @click="sort"
                />
                <tbody>
                    <tr v-for="profile in items" @click="(evt) => handleOpen(profile.profileId, evt)">
                        <td class="primary">
                            {{ profile.name }}
                        </td>
                        <td>{{ $t(`PACING_TYPE_${profile.type}`) }}</td>
                        <td>{{ profile.treatmentId > 0 ? profile.treatmentName : $t('N/A') }}</td>
                        <td>
                            {{ profile.type !== 3 && profile.dropRatioGoal === 0 ? $t('N/A') : profile.dropRatioGoal }}
                        </td>
                        <td>{{ [0, 4, 5].includes(profile.type) ? $t('N/A') : profile.initialPacing }}</td>
                        <td>{{ profile.type === 3 ? profile.maxPacing : $t('N/A') }}</td>
                        <td>{{ profile.type === 3 ? profile.minPacing : $t('N/A') }}</td>
                        <td>
                            {{
                                profile.type === 4 || profile.maxSimultaneous === -1
                                    ? $t('N/A')
                                    : profile.maxSimultaneous
                            }}
                        </td>
                        <td v-if="$store.hasRight('bEditPacingAlgorithms')">
                            <cic-checkbox
                                :value="selected.includes(profile.profileId)"
                                @click="handleSelected(profile.profileId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>

        <edit-pacing-profile
            v-if="item !== null && !$store.showLoadingOverlay"
            :item="item"
            :predictive="predictive"
            :preview-timeout="previewTimeout"
            :queues="queues"
            @blur="closePopup"
            @input="saveItem"
            @updateFieldValue="updateFieldValue"
        />

        <div v-if="$store.showLoadingOverlay" class="cic-overlay"></div>
    </div>
</template>

<script>
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import Panel from '@/components/container/Panel';
    import SortableHeader from '@/components/table/SortableHeader';
    import TableUtils from '@/mixins/TableUtils';
    import { deleteItems, load, save } from '@/utils/Http';
    import { showValidationMessage } from '@/utils/Notification';
    import EditPacingProfile from './EditPacingProfile';
    import '@/css/pacingprofiles.scss';

    export default {
        name: 'PacingProfiles',
        components: {
            Panel,
            SortableHeader,
            EditPacingProfile,
            CicCheckbox,
        },
        mixins: [TableUtils],
        data() {
            return {
                item: null,
                items: [],
                page: 1,
                predictive: false,
                previewTimeout: false,
                queues: [],
                selected: [],
                sorted: {
                    name: 'name',
                    direction: 'asc',
                },
                totalRows: 0,
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            handleDelete() {
                deleteItems('pacingprofiles/delete', { profileIds: this.selected }, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },
            loadTable() {
                this.closePopup();
                load('pacingprofiles/get', { page: this.page, sort: JSON.stringify(this.sorted) }, (response) => {
                    this.items = response.profiles;
                    this.totalRows = response.totalRows;
                    this.predictive = response.predictive;
                    this.previewTimeout = response.previewTimeout;
                });
            },

            openForm(profileId) {
                load('pacingprofile/get', { profileId }, (response) => {
                    this.item = response.profile;
                    this.queues = response.queues;
                });
            },

            saveItem() {
                if (this.item.name.trim() === '') {
                    showValidationMessage('Name is a required field');
                    return;
                }

                const params = { ...this.item };
                params.previewExtend = params.previewExtend ? 1 : 0;
                save('pacingprofile/update', params, () => {
                    this.selected = [];
                    this.loadTable();
                });
            },

            sort(name, direction) {
                this.sorted = { name, direction };
                this.loadTable();
            },
        },
    };
</script>
